export enum PanelClientEditVerificationSectionsEnum {
    SourceOfFunds,
    EmploymentInfo,
    PepDetails,
    JurisdictionalRisk,
    PurposeOfTrading,
    EstimatedWorth,
    ClientDeclarations,
    ComplianceRisk
}
